export const B2B = {
  accountName: 'decathlonpro',
  checkoutUrl: 'https://secure.decathlonpro.com.br/checkout',
  accountUrl: 'https://secure.decathlonpro.com.br/account',
  salesChannel: 1,
  gtmContainerId: 'GTM-MJMQ95DX',
}
